<template>
  <BaseLayout>
    <div class="card card-fullscreen">
      <div class="card-body">
        <LoadingBlock :loading="loadingSettings">
          <div class="row gy-sm-1">
            <div class="col-md-2 mt-2">
              <label class="form-label">Поиск по товарам</label>
              <input type="text" class="form-control border-1 py-2" placeholder="Название, код товара, бренд"
                     v-model="searchData.name" @change="search">
            </div>
            <div class="col-md-2 mt-2">
              <label class="form-label">Поиск по бренду</label>
              <input type="text" class="form-control border-1 py-2" placeholder="Название бренда"
                     v-model="searchData.brand" @change="search">
            </div>
            <div class="col-md-2 mt-2">
              <label class="form-label">Магазин</label>
              <Select v-model="activeStore" :options="stores" optionLabel="name" optionValue="id"
                      @change="setActiveStore"
                      placeholder="Магазин не выбран"
                      style="width: 100%">
              </Select>
            </div>
            <div class="col-md-2 mt-2">
              <label class="form-label">Инфографика</label>
              <Select v-model="searchData.with_infographics" :options="infographicsOptions" optionLabel="name"
                      optionValue="value"
                      @change="search"
                      placeholder="Все"
                      style="width: 100%">
              </Select>
            </div>
            <div class="col-md-2 mt-2">
              <label class="form-label">Сертификаты</label>
              <Select v-model="searchData.has_active_certificate" :options="certificateOptions" optionLabel="name"
                      optionValue="value"
                      @change="search"
                      placeholder="Все"
                      style="width: 100%">
              </Select>
            </div>
            <div class="col-md-2 mt-2">
              <label class="form-label">Фильтр</label>
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="stock-ckeck" v-model="searchData.in_stock"
                       @change="search">
                <label class="form-check-label" for="stock-ckeck">Есть в наличии</label>
              </div>
              <div class="form-check form-switch mb-2">
                <input class="form-check-input" type="checkbox" id="store-check"
                       v-model="searchData.has_not_sent_offer_in_store" @change="search">
                <label class="form-check-label" for="store-check">Не выгружены в выбранный магазин</label>
              </div>
              <div class="form-check form-switch mb-2">
                <input class="form-check-input" type="checkbox" id="store-errors-check"
                       v-model="searchData.with_store_errors" @change="search">
                <label class="form-check-label" for="store-errors-check">Выгружены с ошибками</label>
              </div>
              <div class="form-check form-switch mb-2">
                <input class="form-check-input" type="checkbox" id="without-category-prediction-check"
                       v-model="searchData.without_category_prediction" @change="search">
                <label class="form-check-label" for="without-category-prediction-check">Без предсказания категории</label>
              </div>
              <div class="form-check form-switch mb-2">
                <input class="form-check-input" type="checkbox" id="gpt-without-cache-check"
                       v-model="gptWithoutCache">
                <label class="form-check-label" for="gpt-without-cache-check">GPT без кэша</label>
              </div>
            </div>
            <div class="col-md-2 mt-2">
              <label class="form-label">Размер страницы</label><br>
              <Select v-model="searchData.size" :options="pageSizes" optionLabel="name" optionValue="value"
                      @change="search"
              >
              </Select>
            </div>
            <div class="col-md-3 mt-2">
              <label class="form-label">Массовые действия на странице</label>
              <div>
                <button class="btn btn-outline-primary"
                        @click="setBatchAction('WbDescription')"
                        :disabled="batchDisabled.includes('WbDescription')">
                  AI описание
                </button>
              </div>
              <div>
                <button class="btn btn-outline-primary mt-1" v-if="activeMarketplace === 'wb'"
                        @click="setBatchAction('WbAttributes')"
                        :disabled="batchDisabled.includes('WbAttributes')">
                  AI характеристики
                </button>
              </div>
              <div>
                <button class="btn btn-outline-primary mt-1" v-if="activeMarketplace === 'ozon'"
                        @click="setBatchAction('OzonAttributes')"
                        :disabled="batchDisabled.includes('OzonAttributes')">
                  AI характеристики
                </button>
              </div>
            </div>
            <div class="col-md-6 mt-2">
              <label class="form-label">Массовые действия согласно фильтрам</label>
              <div>
                <button class="btn btn-outline-primary mt-1" v-if="activeMarketplace === 'ozon'"
                        @click="OzonAutoCreate"
                        :disabled="batchDisabled.includes('OzonAutoCreate')">
                  Создать и выгрузить на Озон
                </button>
              </div>
              <div>
                <button class="btn btn-outline-primary mt-1"
                        @click="BatchInfographicsOpen"
                        :disabled="batchDisabled.includes('BatchInfographics')">
                  AI инфографика
                </button>
              </div>
              <div>
                <button class="btn btn-outline-primary mt-1" v-if="activeMarketplace === 'wb'"
                        @click="WbAutoCreate"
                        :disabled="batchDisabled.includes('WbAutoCreate')">
                  Создать и выгрузить на WB
                </button>
              </div>
              <div class="row mt-1">
                <div class="col col-md-6">
                  <button class="btn btn-outline-primary mt-1"
                          @click="UpdateUploadedProductsOpen"
                          :disabled="batchDisabled.includes('UpdateUploadedProducts')">
                    Обновить товары на маркетплейсе
                  </button>
                </div>
              </div>
              <div>
                <button class="btn btn-outline-danger mt-1"
                        @click="DeleteOffersBatch"
                        :disabled="batchDisabled.includes('DeleteOffersBatch')">
                  Удалить офферы
                </button>
                <div class="form-text">
                  Удаляет офферы выбранного магазина в нашей базе по текущим фильтрам
                  (на маркетплейсе карточки не удаляются). Для офферов с ошибками включите
                  «Выгружены с ошибками».
                </div>
              </div>
            </div>

          </div>
          <div v-if="!products.length && !loadingProducts" class="mt-7">
            Товары не найдены
          </div>
        </LoadingBlock>
      </div>
      <div class="card-body">
        <LoadingBlock :loading="loadingOffers || loadingProducts">
          <template v-for="product in products" :key="product.id">
            <div class="row product-row">
              <div class="col-lg-6">
                <MatchProduct :item="product" @attribute-selected="updateProductAttribute"
                              @product-changed="editProduct"/>
              </div>
              <div class="col-lg-6">
                <BaseOffer
                    :offer="offers[product.id]"
                    :marketplace="activeMarketplace"
                    :product="product"
                    :product-attribute="productAttribute"
                    :batch-action="batchAction"
                    :gpt-without-cache="gptWithoutCache"
                    @new-rule="updateOffersList"
                />
              </div>
            </div>
          </template>

          <BasePagination :info="paginationInfo" ref="productsPagination" @changePage="changePage">
          </BasePagination>
        </LoadingBlock>
      </div>
    </div>
  </BaseLayout>
  <BaseModal modalTitle="Инфографика" ref="infographicsModal">
    <div class="row mb-3">
      <div class="col">
        <label class="form-label">Шаблон</label>
        <Select v-model="chosen_template" optionLabel="name" optionValue="id" :options="templates"
                style="width: 100%;"/>
      </div>
      <div class="col">
        <label class="form-label">Доп. карточки</label>
        <input type="text" v-model="secondary_count" class="form-control"/>
      </div>
      <div class="col">
        <ButtonComponent ref="GenerateButton" class="btn btn-primary mt-6" @click="BatchInfographics">
          Сгенерировать
        </ButtonComponent>
      </div>
    </div>
  </BaseModal>
  <BaseModal modalTitle="Обновление товаров" ref="UploadedUpdateModal">
    <div class="row mb-3">
      <div class="col-md-8">
        <label class="form-label">Что обновить?</label>
        <Select v-model="what_to_update" :options="WhatToUpdateOptions" optionLabel="name"
                          optionValue="value" style="width: 100%;"/>
      </div>
      <div class="col">
        <ButtonComponent ref="GenerateButton" class="btn btn-primary mt-6" @click="UpdateUploadedProducts">
          Обновить
        </ButtonComponent>
      </div>
    </div>
    <div v-if="what_to_update === 'characteristics'" class="alert alert-info mb-0">
      Название, описание, бренд, габариты и фото карточки не меняются. Характеристики, заполненные
      в оффере (сертификат/декларация, ТН ВЭД и остальные), перезапишут значения на WB.
      Товары, для ТН ВЭД которых нужен КИЗ (Честный знак), пропускаются.
    </div>
  </BaseModal>
</template>

<script>
import BaseLayout from '@/layouts/Base.vue'
import {PageInfo} from "@/data/page";
import {user} from "@/data/user";
import {stores} from "@/data/store";
import {getProducts, updateProduct} from "@/api/product";
import BasePagination from "@/components/list/Pagination.vue"

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

import {deleteOffersBatch, getOffers, ozonAutoUpload, UpdateUploadedProducts, wbAutoUpload} from "@/api/offer";
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {Select} from "primevue";
import MatchProduct from "@/components/match/Product.vue";
import BaseOffer from "@/components/match/BaseOffer.vue";
import ButtonComponent from "@/components/tools/Button.vue";
import BaseModal from "@/components/Modal.vue";
import {templates} from "@/data/infographics";
import {generateMultiple} from "@/api/infographics";
import {Message, Messages} from "@/data/messages";

export default {
  name: 'MatchView',
  // eslint-disable-next-line vue/no-unused-components
  components: {
    BaseModal, ButtonComponent,
    BaseOffer,
    MatchProduct,
    LoadingBlock, BaseLayout, BasePagination, Select
  },
  emits: ['batch-action'],
  data() {
    return {
      stores: [],
      loadingSettings: true,
      loadingOffers: false,
      loadingProducts: true,
      activeStore: [],
      activeMarketplace: '',
      products: [],
      offers: {},
      offersLoadId: 0,
      paginationInfo: {},
      searchData: {
        name: '',
        brand: '',
        has_not_sent_offer_in_store: true,
        with_store_errors: '',
        without_category_prediction: '',
        in_stock: true,
        size: '20',
        with_infographics: '',
        has_active_certificate: ''
      },
      gptWithoutCache: false,
      productAttribute: null,
      batchAction: null,
      batchDisabled: [],
      pageSizes: [{name: '10', value: '10'}, {name: '20', value: '20'}, {name: '50', value: '50'}, {
        name: '100',
        value: '100'
      }],
      chosen_template: '',
      templates: [],
      secondary_count: 2,
      infographicsOptions: [
        {name: 'Все', value: ''},
        {name: 'Есть', value: 'true'},
        {name: 'Нет', value: 'false'}
      ],
      certificateOptions: [
        {name: 'Все', value: ''},
        {name: 'С актуальным сертификатом', value: 'true'},
        {name: 'Без актуального сертификата', value: 'false'}
      ],
      what_to_update: 'images',
    }
  },
  computed: {
    WhatToUpdateOptions() {
      const options = [
        {name: 'Изображения', value: 'images'},
      ]
      if (this.activeMarketplace === 'wb') {
        options.push({name: 'Характеристики (сертификат, ТН ВЭД)', value: 'characteristics'})
      }
      return options
    },
  },
  methods: {
    async getProducts() {
      this.products = []
      this.batchDisabled = []
      this.loadingProducts = true
      const result = await getProducts(user.active_company, this.$route.query, this.activeStore)
      this.paginationInfo = {
        total: result.data.total,
        pages: result.data.pages,
        page: result.data.page,
        size: result.data.size
      }
      this.products = result.data.items
      this.products.forEach(item => item.is_updating = false)
      this.loadingProducts = false
    },
    async search() {
      const query = {...this.$route.query}
      delete query.page
      Object.entries(this.searchData).forEach(([key, value]) => {
        if (value) {
          query[key] = value
        } else {
          delete query[key]
        }
      });
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...query
        }
      })
    },
    setSearch() {
      if (this.$route.query.name) {
        this.searchData.name = this.$route.query.name
      } else {
        this.searchData.name = ''
      }
      if (this.$route.query.with_infographics) {
        this.searchData.with_infographics = this.$route.query.with_infographics
      } else {
        this.searchData.with_infographics = ''
      }
      if (this.$route.query.has_active_certificate) {
        this.searchData.has_active_certificate = this.$route.query.has_active_certificate
      } else {
        this.searchData.has_active_certificate = ''
      }
      if (this.$route.query.brand) {
        this.searchData.brand = this.$route.query.brand
      } else {
        this.searchData.brand = ''
      }
      if (this.$route.query.size) {
        this.searchData.size = this.$route.query.size
      } else {
        this.searchData.size = '20'
      }
      if (this.$route.query.in_stock) {
        this.searchData.in_stock = this.$route.query.in_stock
      } else {
        this.searchData.in_stock = ''
      }
      if (this.$route.query.has_not_sent_offer_in_store) {
        this.searchData.has_not_sent_offer_in_store = this.$route.query.has_not_sent_offer_in_store
      } else {
        this.searchData.has_not_sent_offer_in_store = ''
      }
      if (this.$route.query.with_store_errors) {
        this.searchData.with_store_errors = this.$route.query.with_store_errors
      } else {
        this.searchData.with_store_errors = ''
      }
      if (this.$route.query.without_category_prediction) {
        this.searchData.without_category_prediction = this.$route.query.without_category_prediction
      } else {
        this.searchData.without_category_prediction = ''
      }
    },
    async changePage(page) {
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: page
        }
      });
    },
    setPageInfo() {
      PageInfo.title = 'Карточки'
      PageInfo.breadcrumbs = [
        {
          title: 'Главная',
          link: '/'
        },
        {
          title: PageInfo.title
        }
      ]
    },
    async setActiveStore() {
      await stores.setActiveStore(this.activeStore)
      const store = this.stores.filter((store) => store.id === this.activeStore)[0]
      this.activeMarketplace = store.marketplace
      await this.loadOffers()
    },
    async loadOffers(products = null) {
      if (!products) {
        products = this.products.map((product) => product.id)
      }
      if (!products.length || !this.activeStore) {
        return
      }

      const loadId = ++this.offersLoadId
      this.loadingOffers = true
      try {
        const company_id = await user.getActiveCompany()
        const offers = await getOffers(company_id, this.activeStore, products)
        if (loadId !== this.offersLoadId) {
          return
        }
        const nextOffers = {}
        offers.data.forEach((offer) => {
          nextOffers[offer.product_id] = offer
        })
        this.offers = nextOffers
      } finally {
        if (loadId === this.offersLoadId) {
          this.loadingOffers = false
        }
      }
    },
    updateProductAttribute(attribute) {
      this.productAttribute = attribute;
    },
    async updateOffersList() {
      await this.loadOffers()
    },
    setBatchAction(action) {
      this.batchAction = action
      this.batchDisabled.push(action)
      setTimeout(() => this.batchAction = null, 100)
    },
    async OzonAutoCreate() {
      this.batchDisabled.push('OzonAutoCreate')
      const data = await this.GetSearchData()
      if (this.gptWithoutCache) {
        data.gtp_without_cache = true
      }
      await ozonAutoUpload(
          this.activeStore,
          data
      )
    },
    UpdateUploadedProductsOpen(){
      const values = this.WhatToUpdateOptions.map((option) => option.value)
      if (!values.includes(this.what_to_update)) {
        this.what_to_update = 'images'
      }
      this.$refs.UploadedUpdateModal.openModal()
    },
    async UpdateUploadedProducts() {
      this.batchDisabled.push('UpdateUploadedProducts')
      const data = await this.GetSearchData()
      this.$refs.UploadedUpdateModal.closeModal()
      await UpdateUploadedProducts(
          this.activeStore,
          this.what_to_update,
          data
      )
    },
    async editProduct(new_data, save = true) {
      const index = this.products.findIndex(item => item.id === new_data.id)
      this.products[index] = {...new_data}
      if (save) {
        this.products[index].is_updating = true
        await updateProduct(this.products[index].id, this.products[index])
        this.products[index].is_updating = false
      }
    },
    async BatchInfographicsOpen() {
      this.templates = await templates.getTemplates()
      this.chosen_template = templates.chosen_template
      this.secondary_count = templates.secondary_count
      this.$refs.infographicsModal.openModal()
    },
    async BatchInfographics() {
      if (this.searchData.with_infographics !== 'false') {
        if (!confirm('Вы хотите сгенерировать инфографику для товаров, у которых они уже есть? Если нет, укажите в фильтрах нужный параметр')) {
          return
        }
      }
      this.batchDisabled.push('BatchInfographics')
      if (!this.chosen_template) {
        alert('Шаблон не выбран')
        return
      }
      const search_data = await this.GetSearchData()
      const data = {
        template_id: this.chosen_template,
        secondary_count: this.secondary_count,
        search_data: search_data
      }
      const res = await generateMultiple(data)
      console.log(res)
      this.$refs.infographicsModal.closeModal()
    },
    async WbAutoCreate() {
      this.batchDisabled.push('WbAutoCreate')
      const data = await this.GetSearchData()
      if (this.gptWithoutCache) {
        data.gtp_without_cache = true
      }
      await wbAutoUpload(
          this.activeStore,
          data
      )
      Messages.list.push(new Message(
          'Выгрузка на WB запущена',
          'Карточки отправляются пачками по 100. Итог по каждой карточке появится в отчёте задачи ' +
          'в течение ~35 минут — обновляйте отчёт, а не ориентируйтесь только на статус задачи.',
          'success', 'notification', 15
      ))
    },
    async DeleteOffersBatch() {
      const store = this.stores.find((item) => item.id === this.activeStore)
      const storeName = store ? store.name : 'выбранного магазина'
      const total = this.paginationInfo.total || 0
      let text = `Удалить офферы магазина «${storeName}» для товаров по текущим фильтрам ` +
          `(товаров под фильтрами: ${total})?\n\nКарточки на маркетплейсе не удаляются, ` +
          `удаляются только офферы в нашей базе.`
      if (!this.searchData.with_store_errors && !this.searchData.has_not_sent_offer_in_store) {
        text += '\n\nВНИМАНИЕ: фильтр «Выгружены с ошибками» не включён — будут удалены ' +
            'в том числе успешно выгруженные офферы.'
      }
      if (!confirm(text)) {
        return
      }
      this.batchDisabled.push('DeleteOffersBatch')
      try {
        const data = await this.GetSearchData()
        const result = await deleteOffersBatch(this.activeStore, data)
        Messages.list.push(new Message(
            'Удаление офферов',
            result.data.message || `Удалено офферов: ${result.data.deleted_count || 0}`,
            'success', 'notification', 10
        ))
        await this.getProducts()
        await this.loadOffers()
      } catch (error) {
        const detail = error.response && error.response.data && error.response.data.detail
        Messages.list.push(new Message(
            'Удаление офферов',
            typeof detail === 'string' ? detail : 'Не удалось удалить офферы',
            'failure', 'notification'
        ))
        this.batchDisabled = this.batchDisabled.filter((item) => item !== 'DeleteOffersBatch')
      }
    },
    async GetSearchData() {
      const search_data = {}
      Object.entries(this.searchData).forEach(([key, value]) => {
        if (value) {
          if (key === 'has_not_sent_offer_in_store') {
            value = this.activeStore
          }
          if (key === 'with_store_errors') {
            value = this.activeStore
          }
          if (key === 'without_category_prediction') {
            value = this.activeStore
          }
          search_data[key] = value
        }
      });
      search_data.company = await user.getActiveCompany()
      return search_data
    }
  },
  async mounted() {
    this.setPageInfo()
    this.setSearch()
    await user.getUserBase()
    this.stores = await stores.getStores()
    this.activeStore = await stores.getActiveStore()
    this.loadingSettings = false
    await this.getProducts()
    await this.setActiveStore()
  },
  watch: {
    async '$route'() {
      this.setSearch()
      this.setPageInfo()
      await this.getProducts()
      await this.setActiveStore()
    }
  }
}
</script>

<style>
.product-row {
  margin: 10px 0;
  border: 2px #eee solid;
  padding: 5px;
  border-radius: 2px;
}
</style>
